import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7deff1da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "homeDiv" }
const _hoisted_2 = { id: "mainBody" }
const _hoisted_3 = { class: "mainBG" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderBody = _resolveComponent("HeaderBody")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_MainBody = _resolveComponent("MainBody")!
  const _component_MainBottom = _resolveComponent("MainBottom")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderBody),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Carousel, { class: "bgImage" }),
        _createVNode(_component_MainBody),
        _createVNode(_component_MainBottom)
      ])
    ])
  ]))
}